// Inter, Raleway, Geist and Plus Jakarta Sans are self-hosted (src/index.css). Loading
// them from Google too would swap in a second copy.
const loadedFonts = new Set<string>(['Raleway', 'Inter', 'Geist', 'Plus Jakarta Sans']);

export function loadGoogleFont(fontFamily: string) {
  const name = fontFamily.split(',')[0].replace(/['"]/g, '').trim();
  if (!name || loadedFonts.has(name)) return;
  loadedFonts.add(name);

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(name)}:wght@400;600;700&display=swap`;
  document.head.appendChild(link);
}

export function loadMultipleGoogleFonts(fontFamilies: string[]) {
  const toLoad = fontFamilies
    .map(f => f.split(',')[0].replace(/['"]/g, '').trim())
    .filter(name => name && !loadedFonts.has(name));

  if (toLoad.length === 0) return;

  toLoad.forEach(name => loadedFonts.add(name));

  const families = toLoad.map(name => `family=${encodeURIComponent(name)}:wght@400;600;700`).join('&');
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?${families}&display=swap`;
  document.head.appendChild(link);
}
